import React from 'react';
import { classNames } from '../utils/classNames';
import { RankValue, rankTierOf } from './rankScale';

// A pill that shows the band of a place in a list: "Top 10", "Top 25", "Top 50",
// "Top 100", "Top 250", "Top 500", and a gray "Not in top 500" for 'over' or a
// place after 500. A null value shows a dash (no value).
// The fill gets lighter from the top band to the last band.
// The caller gives the words in another language with topLabel and overLabel.
type Props = {
	value: RankValue,
	size?: 'normal' | 'large',
	topLabel?: (limit: number) => string,
	overLabel?: string,
	emptyLabel?: string,
	title?: string,
};

const SIZE: Record<'normal' | 'large', string> = {
	normal: 'text-xs',
	large: 'text-sm',
};

const RankTierChip: React.FunctionComponent<Props> = ({
	value,
	size = 'normal',
	topLabel = (limit: number) => `Top ${limit}`,
	overLabel = 'Not in top 500',
	emptyLabel = '–',
	title,
}) => {
	const tier = rankTierOf(value);
	if (tier === undefined) {
		return <span title={title} className={classNames(SIZE[size], 'text-gray-500')}>{emptyLabel}</span>;
	}
	return <span title={title} className={classNames(
		'inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 font-semibold',
		SIZE[size],
		tier.className,
	)}>
		{tier.limit === 'over' ? overLabel : topLabel(tier.limit)}
	</span>;
};

export default RankTierChip;
